import React from 'react';
import './index.css';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root was not found in the document');
}
const root = createRoot(container);
root.render(<BrowserRouter data-id="element-2853">
    <App data-id="element-2854" />
  </BrowserRouter>);